<template>
  <div class="phone-field">
    <div class="value">
      <img class="phone-icon" src="@/assets/style/phone-icon.png" alt="" />
      <input @input="onInput" type="number" pattern="\d*" oninput="value=value.replace(/[^\d]/g,'')" v-model="phone" placeholder="请输入手机号" />
    </div>
  </div>
</template>
<script>
export default {
  name: "phoneField",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      phone: '',
    };
  },
  methods: {
    onInput(val) {
      if (val.target.value.length > 11) {
        this.phone = val.target.value.slice(0, 11);
      }
      this.$emit("input", this.phone);
    },
  },
  watch: {
    value(newVal) {
      this.phone = newVal;
    },
  },
};
</script>
<style scoped lang="scss">
.phone-field {
  display: flex;
  margin-top: 20px;
  height: 54px;
  background: #FFFFFF;
  border-radius: 37px;
  .value {
    display: flex;
    align-items: center;
    .phone-icon {
      width: 20px;
      height: 20px;
      margin-left: 20px;
    }
    input {
      border: none;
      outline: none;
      background: transparent;
      padding-left: 10px;
      &::placeholder {
        color: rgba(51,51,51,0.4);
      }
    }
  }
}
</style>
